/* eslint-disable import/prefer-default-export */
import getConfig from "next/config";

export interface ClientEnv {
	/** 서비스 환경 NODE_ENV
	 * @description local | development | stage | production
	 */
	RUNTIME_ENV: string;

	/** CIMG CDN
	 * @description https://dimgcdn.ybtour.co.kr (.env)
	 */
	ENV_CIMG_CDN_URL: string;

	/** DIMG CDN
	 * @description https://staticdev.ybtour.co.kr (.env.{})
	 */
	ENV_DIMG_CDN_URL: string;

	/** STATIC CDN
	 * @description https://static.ybtour.com (.env)
	 */
	ENV_STATIC_CDN_URL: string;

	/** 계정관리 API 도메인 주소
	 * @description https://account.ybtour.co.kr (.env.{})
	 */
	ENV_ACCOUNTS_API_DOMAIN: string;

	/** 계정관리 웹 도메인
	 * @description https://account.ybtour.co.kr (.env.{})
	 */
	ENV_ACCOUNTS_DOMAIN: string;

	/** YBmain 도메인
	 * @description https://pkg.ybtour.co.kr (.env.{})
	 */
	ENV_PACKAGE_URL: string;

	/** YBmain 모바일 도메인
	 * @description https://mpkg.ybtour.co.kr (.env.{})
	 */
	ENV_PACKAGE_M_URL: string;

	/** Portal 도메인
	 * @description https://www.ybtour.co.kr (.env.{})
	 */
	ENV_PORTAL_URL: string;

	/** Portal 도메인 모바일
	 * @description https://www.ybtour.co.kr/m (.env.{})
	 */
	ENV_PORTAL_M_URL: string;

	/** portal API basepath
	 * @description (.env.{})
	 */
	ENV_PORTAL_API_URL: string;

	/** Support 도메인
	 * @description (.env.{})
	 */
	ENV_SUPPORT_URL: string;

	/** Travel 도메인
	 * @description https://travel.ybtour.co.kr (.env.{})
	 */
	ENV_TRAVEL_URL: string;

	/** 카카오 APP KEY
	 * @description (.env.{})
	 */
	ENV_KAKAO_APP_KEY: string;

	/** OTA 도메인
	 * @description https://ota.ybtour.co.kr (.env.{})
	 */
	ENV_OTA_URL: string;

	/** OTA 모바일 도메인
	 * @description https://mota.ybtour.co.kr (.env.{})
	 */
	ENV_OTA_M_URL: string;

	/** FIT 도메인
	 * @description https://fit.ybtour.co.kr (.env.{})
	 */
	ENV_FIT_URL: string;

	/** 상품전시 도메인
	 * @description https://prdt.ybtour.co.kr (.env.{})
	 */
	ENV_PRODUCT_URL: string;

	/** 공통 API basepath
	 * @description https://api.ybtour.co.kr/* (.env.{})
	 */
	ENV_ESSENTIAL_API_BASEPATH: string;

	/** 코러스 API basepath
	 * @description https://api.ybtour.co.kr/* (.env.{})
	 */
	ENV_CHORUS_API_BASEPATH: string;

	/** 노랑풍선 company
	 * @description https://company.ybtour.co.kr (.env.{})
	 */
	ENV_COMPANY_URL: string;

	/**
	 * 공통 CND
	 * @description https://scdn-dev.ybtour.co.kr/"
	 */
	ENV_SCDN_URL: string;

	/** Braze API
	 * @description Braze api key (SDK 클라이언트용)
	 */
	ENV_BRAZE_APIKEY: string;

	/** Braze API
	 * @description Braze enable log
	 */
	ENV_BRAZE_ENABLE_LOG: string;

	/** Amplitude API
	 * @description Amplitude api key (SDK 클라이언트용)
	 */
	ENV_AMPLITUDE_APIKEY: string;

	/** Amplitude API
	 * @description Amplitude log level
	 */
	ENV_AMPLITUDE_LOG_LEVEL: string;

	/** tagging component
	 * @description env
	 */
	COMPONENT_ENV: string;

	/** 항공 세이버
	 * @description https://mfly.ybtour.co.kr
	 */
	ENV_FLIGHT_SABRE_M_URL: string;
}

const {publicRuntimeConfig}: {publicRuntimeConfig: ClientEnv} = getConfig();

export default publicRuntimeConfig;
